import { render, staticRenderFns } from "./OrderPriceBreakDown.vue?vue&type=template&id=a11d35fa"
import script from "./OrderPriceBreakDown.vue?vue&type=script&lang=js"
export * from "./OrderPriceBreakDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports